module.exports = __webpack_public_path__ + "static/jneexpress-black-b72b02e46770b29cdebf3fc5bcffbc6f.svg";